export var ModalType;
(function (ModalType) {
    ModalType["Create"] = "Create";
    ModalType["Edit"] = "Edit";
})(ModalType || (ModalType = {}));
export const TAB_SEARCH_PARAM_KEY = 'tab';
//# sourceMappingURL=common.js.map